import { ActionTypes as types } from 'constants';

export default () => dispatch => {
  dispatch({
    type: types.CLOSE_CONSENT_MODAL,
  });
};
